module.exports = __webpack_public_path__ + "cancellara-dist/img/poste-welfare.c7b02195.png";